import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../styles/colors';
import BackButton from './BackButton';
import MobileDestinations from './MobileDestinations';
import { MainHeading, SubHeading, LiComponent } from '../components/Menus';
import { countries } from '../constants/menuItems';
import Image from './Image';
interface MenuProps {
  children: any;
}

export const Layout = ({ children }: MenuProps) => {
  const [showResults, setShowResults] = React.useState(false);

  return (
    <>
      {!showResults ? (
        <Box
          p='1.25rem 1.875rem'
          sx={{
            backgroundColor: colors.basics.lightmain,
            '& .right_icon ': {
              height: '10px',
              width: '10px',
            },
            // SubHeading css
            '& .side_ul': {
              pb: '60px',
            },

            '& li .bottom_title': {
              color: colors.basics.primary,
            },
            //For SubHeading arrow css
            '& ul li .bottom_title': {
              '& svg': {
                '& path': { fill: 'red' },
              },
              '&:hover': {
                textDecoration: 'underline',
              },
            },
            '& .main_heading': {
              // padding: '0px 15px',
            },

            '& .main_heading>a': {
              '&:hover': {
                textDecoration: 'underline',
                color: colors.basics.primary,
                fontFamily: 'Raleway,sans-serif',
              },
            },

            '& .heading': { color: colors.basics.primary, fontSize: '20px', fontWeight: 400, mb: 2, mt: 1 },
            '& a': {
              textDecoration: 'none',
            },
            //Right heading css
            '& .heading_right>a': { '&:hover': { textDecoration: 'underline', color: '#303030' } },
            // LiComponent css
            '& ul': { '& li': { padding: '0 10px 20px', '& a': { fontSize: '16px', color: '#303030' } } },
            '& ul li a': {
              '&:hover': {
                color: colors.basics.primary,
              },
            },
            '& .li_title': {
              padding: '0px 0px 30px 0px',
            },
            '& .back_button': {
              m: '10px 0px 0px 0px',
              pb: '10px',
              pl: '0px',
            },
          }}
        >
          <Box pl='10px' pt='10px' className='back_button' onClick={() => setShowResults(true)}>
            <BackButton />
          </Box>
          {children}
        </Box>
      ) : (
        <MobileDestinations />
      )}
    </>
  );
};

export const Africa = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },

            '& .first_ul': {
              padding: '10px 30px 0 0',
            },
            '& .li_title': {
              position: 'relative',
              '&:after': {
                content: '""',
                height: '1px',
                width: '230px',
                position: 'absolute',
                bgcolor: '#939292',
                top: '35px',
                left: '0',
              },
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Africa Destinations' />
            <Box p='0 0 0'>
              <ul className='first_ul'>
                <Box mb='.950rem'>
                  <Typography variant='subtitle1' fontSize='20px' fontWeight={400}>
                    With Tropical Sky
                  </Typography>
                </Box>
                {countries.africa.map((country, i) => (
                  <LiComponent name={country} href={countries.africaHolidaysLinks[i]} key={i} />
                ))}

                <SubHeading text='All Tropical Sky Destinations ' />
              </ul>
              <ul className='side_ul'>
                <Box mb={2} mt={3}>
                  <Box className='heading_right'>
                    <a href='https://www.africaskysafari.com/' target='_blank' rel='noreferrer'>
                      <Typography variant='subtitle1' fontSize='20px' fontWeight={400}>
                        With Africa Sky
                      </Typography>
                    </a>
                  </Box>
                  <Box>
                    <Image
                      src={`${process.env.REACT_APP_REDIRECT_URL}FrontEndGlobalAssets/dist/img/brands/africasky.svg`}
                      alt='AfricaLogo'
                    />
                  </Box>
                  <Box mt={2} mb={2}>
                    <Typography variant='subtitle2' maxWidth='230px' fontSize='.85rem'>
                      To view our Africa destinations visit our specialist Africa Sky site here
                    </Typography>
                  </Box>
                </Box>
                <LiComponent name='Botswana' href='https://www.africaskysafari.com/botswana-safaris' />
                <LiComponent name='Zambia' href='https://www.africaskysafari.com/zambia-safaris' />
                <LiComponent name='Uganda' href='https://www.africaskysafari.com/uganda-safaris' />
                <LiComponent name='Zimbabwe' href='https://www.africaskysafari.com/zimbabwe-safaris' />
                <LiComponent name='Rwanda' href='https://www.africaskysafari.com/rwanda-safaris' />
                <LiComponent name='Victoria Falls' href='https://www.africaskysafari.com/victoria-falls' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};
export const Australia = () => {
  return (
    <>
      <Layout>
        <Box
          height='100%'
          sx={{
            '& ul': { listStyle: 'none' },
            '& .first_ul': {
              '& .border_class': {
                borderTop: '1px solid #939292',
                borderBottom: '1px solid #939292',
                maxWidth: '230px',
                pb: '30px',
                pt: '20px',
              },
              ' & li': {
                padding: '0px 0px ',
              },
              padding: '10px 10px 10px 0px',
            },
          }}
        >
          <Box>
            <Box p='10px 0 0'>
              <Box
                sx={{
                  '& img': {
                    maxWidth: '140px',
                  },
                }}
              >
                <ul className='first_ul'>
                  <Box sx={{ mb: 3 }}>
                    <Typography variant='subtitle1' fontSize='20px' fontWeight={400}>
                      With Tropical Sky
                    </Typography>
                  </Box>
                  {countries.australia.map((country, i) => (
                    <LiComponent name={country} href={countries.australiaHolidaysLinks[i]} key={i} />
                  ))}
                </ul>
                <ul className='first_ul'>
                  <Box p='10px 0px 20px 0px' className='border_class'>
                    <Box className='heading_right'>
                      <a href='https://www.australiansky.co.uk/' target='_blank' rel='noreferrer'>
                        <Typography variant='subtitle1' fontSize='20px' fontWeight={400}>
                          With Australian Sky
                        </Typography>
                      </a>
                    </Box>

                    <Box sx={{ mt: 2 }}>
                      <a href='https://www.australiansky.co.uk/' target='_blank' rel='noreferrer'>
                        <Image
                          src={`${process.env.REACT_APP_REDIRECT_URL}FrontEndGlobalAssets/dist/img/brands/australiansky.svg`}
                          alt='AustralianLogo'
                        />
                      </a>
                    </Box>
                    <Box sx={{ mt: 2 }}>
                      <Typography variant='subtitle2' maxWidth='210px' fontSize='.85rem'>
                        To view our Australia destinations visit our specialist Australian Sky site here
                      </Typography>
                    </Box>
                  </Box>
                </ul>
                <ul className='first_ul'>
                  <Box>
                    <Box className='heading_right'>
                      <a href='https://www.newzealandsky.co.uk/' target='_blank' rel='noreferrer'>
                        <Typography variant='subtitle1' fontSize='20px' fontWeight={400}>
                          With New Zealand Sky
                        </Typography>
                      </a>
                    </Box>
                    <Box mt={2}>
                      <a href='https://www.newzealandsky.co.uk/' target='_blank' rel='noreferrer'>
                        <Image
                          src={`${process.env.REACT_APP_REDIRECT_URL}FrontEndGlobalAssets/dist/img/brands/newzealandsky.svg`}
                          alt=' NewZealandLogo'
                        />
                      </a>
                    </Box>
                    <Box mt={2}>
                      <Typography variant='subtitle2' maxWidth='210px' fontSize='.85rem'>
                        To view our New Zealand destinations visit our specialist New Zealand Sky site here
                      </Typography>
                    </Box>
                  </Box>
                </ul>
              </Box>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};
export const Caribbean = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& .first_ul': {
              padding: '0 30px 20px 0px',
              flex: '0 0 50%',
            },
            '& ul': {
              '& li': {
                listStyle: 'none',
                padding: '0 10px 20px',
                '& a': { fontSize: '16px', color: '#303030' },
              },
            },
            '& ul li a': {
              '&:hover': {
                color: colors.basics.primary,
              },
            },
            '& .li_title': {
              padding: '0px 0px 30px 0px',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Caribbean Destinations' />
            <Box p='10px 0 40px'>
              <ul className='first_ul'>
                {countries.caribbean.map((country, i) => (
                  <LiComponent name={country} href={countries.caribbeanHolidaysLinks[i]} key={i} />
                ))}

                <SubHeading text='All Caribbean Destinations ' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};
export const Dubai = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '& .first_ul': {
              padding: '10px 30px 30px 0',
              flex: '0 0 50%',
            },
            '& .li_title': {
              padding: '0px 0px 30px 0px',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Dubai & Middle East Destinations' />
            <Box p='5px 0 0'>
              <ul className='first_ul'>
                {countries.middleEast.map((country, i) => (
                  <LiComponent name={country} href={countries.middleEastHolidaysLinks[i]} key={i} />
                ))}
                <SubHeading text='All Dubai & Middle East Destinations' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};
export const Europe = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '& .first_ul': {
              padding: '0 30px 0 0',
              flex: '0 0 50%',
            },
            '& .li_title': {
              padding: '0px 0px 30px 0px',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Europe Destinations' />
            <Box p='0 0 0'>
              <ul className='first_ul'>
                {countries.europe.map((country, i) => (
                  <LiComponent name={country} href={countries.europeHolidaysLinks[i]} key={i} />
                ))}
                <SubHeading text='All Europe Destinations' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};
export const EastAsia = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '& .first_ul': {
              padding: '10px 30px 30px 0',
              flex: '0 0 50%',
            },
            '& .li_title': {
              padding: '0px 0px 30px 0px',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Far East & Asia Destinations' />
            <Box p='5px 0 0'>
              <ul className='first_ul'>
                {countries.farEast.map((country, i) => (
                  <LiComponent name={country} href={countries.farEastHolidaysLinks[i]} key={i} />
                ))}
                <SubHeading text='All Far East & Asia Destinations' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};
export const IndiaOcean = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '& .first_ul': {
              padding: '10px 30px 30px 0',
              flex: '0 0 50%',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Indian Ocean Destinations' />
            <Box p='5px 0 0'>
              <ul className='first_ul'>
                {countries.indiaOcean.map((country, i) => (
                  <LiComponent name={country} href={countries.indianOceanHolidaysLinks[i]} key={i} />
                ))}
                <SubHeading text='All Indian Ocean Destinations' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};
export const NorthAmerica = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            height: '100%',
            '& ul': { listStyle: 'none' },
            '& .first_ul': {
              position: 'relative',
              '& .border_class': {
                borderTop: '1px solid #939292',
                borderBottom: '1px solid #939292',
                maxWidth: '230px',
              },
              '& li': {
                padding: '0px 0px 20px 0px',
              },
            },
          }}
        >
          <Box>
            <Box pt='20px'>
              <Box
                sx={{
                  '& img': {
                    maxWidth: '140px',
                  },
                }}
              >
                <ul className='first_ul'>
                  <Box p='20px 0' className='border_class'>
                    <Box className='heading_right'>
                      <a href='https://www.americansky.co.uk/' target='_blank' rel='noreferrer'>
                        <Typography variant='subtitle1' fontSize='20px' fontWeight={400}>
                          With American Sky
                        </Typography>
                      </a>
                    </Box>
                    <Box mt={2}>
                      <a href='https://www.americansky.co.uk/' target='_blank' rel='noreferrer'>
                        <Image
                          src={`${process.env.REACT_APP_REDIRECT_URL}FrontEndGlobalAssets/dist/img/brands/americansky.svg`}
                          alt='AmericanLogo'
                        />
                      </a>
                    </Box>
                    <Box mt={2} mb={2}>
                      <Typography variant='subtitle2' maxWidth='230px' fontSize='.85rem'>
                        To view our USA destinations visit our specialist American Sky site here
                      </Typography>
                    </Box>
                    <LiComponent name='Florida' href='https://www.americansky.co.uk/florida-holidays' />
                    <LiComponent name='Hawaii' href='https://www.americansky.co.uk/hawaii-holidays' />
                  </Box>
                </ul>
                <ul className='first_ul'>
                  <Box p='1.25rem 0'>
                    <Box className='heading_right'>
                      <a href='https://www.canadiansky.co.uk/' target='_blank' rel='noreferrer'>
                        <Typography variant='subtitle1' fontSize='20px' fontWeight={400}>
                          With Canadian Sky
                        </Typography>
                      </a>
                    </Box>
                    <Box mt={2}>
                      <a href='https://www.canadiansky.co.uk/' target='_blank' rel='noreferrer'>
                        <Image
                          src={`${process.env.REACT_APP_REDIRECT_URL}FrontEndGlobalAssets/dist/img/brands/canadiansky.svg`}
                          alt='CanadianLogo'
                        />
                      </a>
                    </Box>
                    <Box mt={2}>
                      <Typography variant='subtitle2' maxWidth='230px' fontSize='.85rem'>
                        To view our Canada destinations visit our specialist Canadian Sky site here
                      </Typography>
                    </Box>
                  </Box>
                </ul>
              </Box>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};
export const Polar = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '& .first_ul': {
              padding: '10px 30px 30px 0',
              flex: '0 0 50%',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Polar Destinations' />
            <Box p='5px 0 0'>
              <ul className='first_ul'>
                {countries.polar.map((country, i) => (
                  <LiComponent name={country} href={countries.polarHolidaysLinks[i]} key={i} />
                ))}
                <SubHeading text='All Polar Destinations' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};
export const South = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '& .first_ul': {
              padding: '10px 30px 30px 0',
              flex: '0 0 50%',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='South & Central America Destinations' />
            <Box p='5px 0 0'>
              <ul className='first_ul'>
                {countries.southCentralAmerica.map((country, i) => (
                  <LiComponent name={country} href={countries.southCentralAmericaHolidaysLinks[i]} key={i} />
                ))}
                <SubHeading text='All South & Central America Destinations' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};
